import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from '../../../Common/DataTable';
import { Edit, UserPlus, UserX } from 'react-feather';
import { H5, Btn } from '../../../../AbstractElements';
import { toast } from 'react-toastify';
import { assignFinalCompensationToSelf, releaseFinalCompensationFromSelf } from '../../../../Api/ApiMethods';

const CompensationInfo = ({ finalCompensations = [], onDataChange, isLoading = false, title = 'Kapaklar', noDataMessage = 'Müşteriye ait kapak bulunamadı.' }) => {
    const navigate = useNavigate();
    const [isAssigning, setIsAssigning] = useState(false);
    const [isReleasing, setIsReleasing] = useState(false);

    const handleAssignToSelf = async (compensationId) => {
        if (isAssigning) return;
        setIsAssigning(true);
        try {
            await assignFinalCompensationToSelf({ finalCompensationId: compensationId });
            toast.success('Kapak kendinize atandı.');
            if (onDataChange) onDataChange();
        } catch { }
        finally { setIsAssigning(false); }
    };

    const handleReleaseFromSelf = async (compensationId) => {
        if (isReleasing) return;
        setIsReleasing(true);
        try {
            await releaseFinalCompensationFromSelf({ finalCompensationId: compensationId });
            toast.success('Kapak görevi kaldırıldı.');
            if (onDataChange) onDataChange();
        } catch { }
        finally { setIsReleasing(false); }
    };

    const formatCurrency = (value) => {
        if (value == null) return '-';
        return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(value);
    };

    const formatDate = (value) => {
        if (!value) return '-';
        return new Date(value).toLocaleDateString('tr-TR');
    };

    const columns = [
        { name: 'Plaka', selector: row => row.licensePlate || '-', sortable: true, minWidth: '100px' },
        { name: 'Kaza Tarihi', selector: row => formatDate(row.accidentDate), sortable: true, minWidth: '110px' },
        { name: 'İcra Dosya No', selector: row => row.enforcementCaseNumber || '-', sortable: true, minWidth: '130px' },
        {
            name: 'Tahsilat Tutarı',
            selector: row => {
                const pc = row.paymentCollections;
                return formatCurrency(pc?.amount || row.collectedAmount);
            },
            sortable: true,
            minWidth: '130px'
        },
        { name: 'Ödeme Tarihi', selector: row => formatDate(row.paymentDate || row.paymentCollections?.date), sortable: true, minWidth: '110px' },
        {
            name: 'Ata / Kaldır',
            cell: (row) => {
                const appointedUser = row.appointedUser || row.appointedUsers;
                const hasAppointedUser = appointedUser && (
                    Array.isArray(appointedUser)
                        ? appointedUser.filter(u => !!u && String(u).trim() !== '').length > 0
                        : !!appointedUser
                );

                if (!hasAppointedUser) {
                    return (
                        <Btn attrBtn={{ color: 'outline-primary', size: 'sm', onClick: () => handleAssignToSelf(row.id), title: 'Kendine Ata', disabled: isAssigning }}>
                            <UserPlus size={16} />
                        </Btn>
                    );
                }

                return (
                    <Btn attrBtn={{ color: 'outline-danger', size: 'sm', onClick: () => handleReleaseFromSelf(row.id), title: 'Kendinden Kaldır', disabled: isReleasing }}>
                        <UserX size={16} />
                    </Btn>
                );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '100px',
            center: true
        },
        {
            name: 'Detay',
            cell: (row) => (
                <div
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => navigate(`${process.env.PUBLIC_URL}/compensation-detail/${row.id}`)}
                    title="Kapak Detayı"
                >
                    <Edit size={16} />
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '70px',
            center: true
        },
    ];

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <H5>{title}</H5>
                <div style={{ height: '38px' }} aria-hidden="true" />
            </div>
            <div style={{ minHeight: '200px' }}>
                <DataTable
                    columns={columns}
                    data={finalCompensations}
                    pagination
                    paginationPerPage={10}
                    progressPending={isLoading}
                    progressComponent={<div className="py-4 text-center">Yükleniyor...</div>}
                    noDataComponent={isLoading ? null : (
                        <div className="w-100 text-start">{noDataMessage}</div>
                    )}
                />
            </div>
        </>
    );
};

export default CompensationInfo;
